export const GET_WALLETS_START = 'GET_WALLETS_START';
export const GET_WALLETS_ERROR = 'GET_WALLETS_ERROR';
export const GET_WALLETS_SUCCESS = 'GET_WALLETS_SUCCESS';
